import { debounce } from "lodash"

export const calculateVisibleHeaderHeight = () => {
    const header = document.querySelector(".header-wrapper")

    document.documentElement.style.setProperty("--header-offset", `${header.clientHeight}px`)
}

window.addEventListener("resize", debounce(calculateVisibleHeaderHeight, 150))
;(function () {
    calculateVisibleHeaderHeight()
})()
